import { Injectable } from '@angular/core';
import { SessionContext } from 'src/app/core/model/sessionContext';
import { LanguageFlag } from '../_base/layout/models/languageFlag';

@Injectable({
    providedIn: 'root',
})
export class SessionBusiness {
    private _sessionContext: SessionContext;
    public languageSelected: LanguageFlag;

    constructor() {
        const context = sessionStorage.getItem('ContextSelected');
        this._sessionContext = context ? JSON.parse(context) : ({} as SessionContext); // Initialize as empty object to avoid undefined errors
    }

    get EntityIdContext(): string {
        return this._sessionContext?.EntityId ?? 'NotFound';
    }

    set EntityIdContext(value: string) {
        this._sessionContext.EntityId = value;
        this.updateSessionStorage();
    }

    get SdaSystemIdContext(): string {
        return this._sessionContext?.SystemId ?? 'NotFound';
    }

    set SdaSystemIdContext(value: string) {
        this._sessionContext.SystemId = value;
        this.updateSessionStorage();
    }

    get LegalEntityIdContext(): string {
        return this._sessionContext?.LegalEntityId ?? 'NotFound';
    }

    set LegalEntityIdContext(value: string) {
        this._sessionContext.LegalEntityId = value;
        this.updateSessionStorage();
    }

    get EntityDescriptionContext(): string {
        return this._sessionContext?.EntityDescription ?? 'NotFound';
    }

    set EntityDescriptionContext(value: string) {
        this._sessionContext.EntityDescription = value;
        this.updateSessionStorage();
    }

    get SdaSystemNameContext(): string {
        return this._sessionContext?.SystemName ?? 'NotFound';
    }

    set SdaSystemNameContext(value: string) {
        this._sessionContext.SystemName = value;
        this.updateSessionStorage();
    }

    get CountryIdContext(): Number {
        return this._sessionContext?.CountryId ?? 0;
    }

    set CountryIdContext(value: Number) {
        this._sessionContext.CountryId = value;
        this.updateSessionStorage();
    }

    get Context(): SessionContext {
        return this._sessionContext;
    }

    set Context(value: SessionContext) {
        this._sessionContext = value;
        this.updateSessionStorage();
    }

    private updateSessionStorage() {
        sessionStorage.setItem('ContextSelected', JSON.stringify(this._sessionContext));
    }
}
